import { render, staticRenderFns } from "./AiExercise.vue?vue&type=template&id=a4b81db2&scoped=true"
import script from "./AiExercise.vue?vue&type=script&lang=js"
export * from "./AiExercise.vue?vue&type=script&lang=js"
import style0 from "./AiExercise.vue?vue&type=style&index=0&id=a4b81db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b81db2",
  null
  
)

export default component.exports